<div>
  <label class="tw-block tw-mb-2 tw-text-sm tw-font-medium tw-text-gray-900">{{
    label
  }}</label>
  <input
    type="range"
    class="range-input"
    [min]="min"
    [max]="max"
    [step]="step"
    [(ngModel)]="value"
    (change)="handleChangeValue($event)"
  />
  <div
    class="tw-mt-2 range-labels"
    [ngStyle]="{ '--list-length': options.length }"
  >
    @for (option of options; track option.value) {
      <p class="tw-text-xs tw-text-gray-600">
        {{ option.label ? ('slider.' + option.label | translate) : '' }}
      </p>
    }
  </div>
  <div
    class="tw-mt-1 tw-text-sm tw-flex tw-items-center tw-gap-1 {{
      isError ? 'tw-text-red-500' : ''
    }}"
  >
    @if (isError) {
      <ng-container>
        <span class="material-icons tw-mr-1 tw-text-xl">error_outline</span>
      </ng-container>
    }
    {{ helperText }}
  </div>
</div>
